<template>
  <div class="profitableListDetail">
    <van-form label-width="120px">
      <div class="title">{{ $t.meta.basicTitle }}</div>
      <van-field
        v-model="form.PWB_Number"
        :label="$t.profitableList.mainWbNumber"
        readonly
      />
      <van-field
        v-model="form.WB_Number"
        :label="$t.profitableList.sideWbNumber"
        readonly
      />
      <van-field
        v-model="form.WarehouseWorkNumber"
        :label="$t.profitableList.warehouseWorkNumber"
        readonly
      />
      <van-field
        v-model="form.WorkOrderNumber"
        :label="$t.profitableList.jobNumber"
        readonly
      />
      <van-field v-model="form.InvoiceNo" :label="$t.profitableList.invoiceNo" readonly />
      <van-field
        v-model="form.OperationUserName"
        :label="$t.profitableList.usType1"
        readonly
      />
      <van-field
        v-model="form.SalesUserName"
        :label="$t.profitableList.usType2"
        readonly
      />
      <van-field
        v-model="form.CustomerServiceUserName"
        :label="$t.profitableList.usType3"
        readonly
      />
      <van-field
        v-model="form.MarketUserName"
        :label="$t.profitableList.usType4"
        readonly
      />
      <div class="title">{{ $t.profitableList.tradeTitle }}</div>
      <van-field v-model="form.POL" :label="$t.profitableList.deliveryPort" readonly />
      <van-field v-model="form.POD" :label="$t.profitableList.destinationPort" readonly />
      <van-field v-model="form.ATD" :label="$t.profitableList.atd" readonly />
      <div class="title">{{ $t.profitableList.amountDetail }}</div>

      <van-field
        v-model="form.ReceivedTotalAmount"
        :label="$t.profitableList.receivedTotal + '(' + settlementCurrency + ')'"
        readonly
      />

      <div class="subTotal" v-if="form.ReceivedList && form.ReceivedList.length > 0">
        <div class="subTotal-label">{{ $t.profitableList.receivedAmount }}</div>
        <div
          class="subTotal-item"
          v-for="(item, index) in form.ReceivedList"
          :key="index"
        >
          <div class="item1">{{ item.CurrencySn }}</div>
          <div class="item2">{{ item.TotalAmount }}</div>
        </div>
      </div>

      <van-field
        style="margin-top: 15px"
        v-model="form.PaidTotalAmount"
        :label="$t.profitableList.paidTotal + '(' + settlementCurrency + ')'"
        readonly
      />

      <div class="subTotal" v-if="form.PaidList && form.PaidList.length > 0">
        <div class="subTotal-label">{{ $t.profitableList.payAmount }}</div>
        <div class="subTotal-item" v-for="(item, index) in form.PaidList" :key="index">
          <div class="item1">{{ item.CurrencySn }}</div>
          <div class="item2">{{ item.TotalAmount }}</div>
        </div>
      </div>

      <van-field
        style="margin-top: 15px"
        v-model="form.ProfitsSubTotal"
        :label="$t.profitableList.subProfit + '(' + settlementCurrency + ')'"
        readonly
      />

      <div class="subTotal" v-if="rateList && rateList.length > 0">
        <div class="subTotal-label">{{ $t.profitableList.rate }}</div>
        <div class="subTotal-item" v-for="(item, index) in rateList" :key="index">
          <div class="item1">{{ item.CurrencySn }}</div>
          <div class="item2">{{ item.Rate }}</div>
        </div>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, Uploader, Picker, Popup, Stepper } from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Uploader)
  .use(Picker)
  .use(Popup)
  .use(Stepper);

export default {
  name: "profitableListDetail",
  data() {
    return {
      SettlementCurrency: "",
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      rateList: [],
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("profitableListDetail"));
    this.form = data;
    this.settlementCurrency = data.SettlementCurrency;
    this.rateList = data.RateList;
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.profitableListDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .subTotal {
    padding: 15px;
    font-size: 14px;
    color: #646566;
    .subTotal-label {
      margin-bottom: 15px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
}
</style>
